import { createContext, useContext } from "react";
import type { RoleValue } from "../lib/role-helpers";

/**
 * SPEC-Auth-Users-Roles-Audit — RoleContext.
 *
 * Default value used before `/api/auth/check-approved` resolves. Every field
 * is safe (all `false`/`null`) so any consumer that destructures
 * `useRole()` pre-resolution renders an "unauthenticated" view.
 */
export const RoleContext = createContext<RoleValue>({
  role: null,
  isAgent: false,
  isSenior: false,
  isAdmin: false,
  isBot: false,
  dev: false,
  name: null,
  email: null,
  userId: null,
});

export function useRole(): RoleValue {
  return useContext(RoleContext);
}

export type { RoleValue };
